import axios from './_nestAxios'

export const obtenerxIdAsEdicion = _id => axios.get(`/kardex/${_id}`, { params: { tipoConsulta: 'saldos-iniciales' } })

export const validarExistenciaSaldosIniciales = () => axios.get('kardex/validar-existencia-saldos-iniciales')

export const getSaldoInicial_SoloDetalles = busqueda => axios.get('/kardex/saldos-iniciales/solo-detalles', { params: { busqueda: busqueda } })

export const getReporte = () => axios.get('/kardex/descargar/reporte-saldos-iniciales', { responseType: 'blob' })

export const nuevoSaldoInicial = data => axios.post('/kardex/saldos-iniciales', data)

export const actualizarxId = (id, data) => axios.put(`/kardex/saldos-iniciales/${id}`, data)

export const actualizarSoloDetalles = data => axios.put('/kardex/saldos-iniciales/solo-detalles', data)

export const eliminarSaldoInicial = id => axios.delete(`/kardex/${id}`)
